// extracted by mini-css-extract-plugin
module.exports = {"timer":"clock_timer__2O9KE","time":"clock_time__3DBlu"};